var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { E_CASES_ACTION_TYPES } from './actionTypes';
import { completionFilter, etudeDossierFilter, messageFilter, otherFilter } from 'src/redux/cases/constants';
import { E_REQUEST_STATUS } from 'src/shared/types';
var initialState = {
    allQueries: [],
    allColumns: [],
    exportIsLoading: false,
    collection: {
        results: [],
        isLoading: false,
        status: E_REQUEST_STATUS.IDLE,
        total: 0,
        filters: null,
        defaultFilters: null,
        defaultColumns: [],
        columns: [],
    },
    current: {
        studyElements: null,
        applicants: [],
        isLoading: false,
        actionModal: {
            content: null,
            isLoading: false,
        },
        actions: [],
        contracts: [],
        data: null,
        lock: null,
        documents: null,
        hardData: null,
        history: {
            events: [],
            filters: {
                all: [messageFilter, etudeDossierFilter, completionFilter, otherFilter],
                current: [messageFilter, etudeDossierFilter, completionFilter],
            },
        },
        comments: [],
        soa3UploadPath: '',
        modal: {
            cache: null,
        },
    },
    currentApplicantId: null,
    currentTemplate: null,
    isNotificationsActivated: false,
    autoPlay: false,
};
export var casesReducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case E_CASES_ACTION_TYPES.RESET_CASES: {
            return initialState;
        }
        case E_CASES_ACTION_TYPES.RESET_CASES_COLLECTION_RESULT: {
            return __assign(__assign({}, state), { collection: __assign(__assign({}, state.collection), { results: [] }) });
        }
        case E_CASES_ACTION_TYPES.FETCH_AUTO_SEARCH_SUCCEEDED:
        case E_CASES_ACTION_TYPES.FETCH_CASES_SUCCEEDED: {
            var collectionResults = action.collectionResults, total = action.total;
            return __assign(__assign({}, state), { collection: __assign(__assign({}, state.collection), { results: collectionResults, total: total, status: E_REQUEST_STATUS.FINISHED }) });
        }
        case E_CASES_ACTION_TYPES.UPDATE_CASES_COLLECTION_LOADING: {
            var isLoading = action.isLoading;
            return __assign(__assign({}, state), { collection: __assign(__assign({}, state.collection), { isLoading: isLoading, status: isLoading ? E_REQUEST_STATUS.LOADING : E_REQUEST_STATUS.FINISHED }) });
        }
        case E_CASES_ACTION_TYPES.FETCH_CURRENT_CASE_DETAILS_SUCCEEDED: {
            var currentCase = action.currentCase, hardData = action.hardData;
            var applicants = currentCase.applicants, actions = currentCase.actions, documents = currentCase.documents, contracts = currentCase.contracts, soa3UploadModulePath = currentCase.soa3UploadModulePath, lock = currentCase.lock, studyElements = currentCase.studyElements, rest = __rest(currentCase, ["applicants", "actions", "documents", "contracts", "soa3UploadModulePath", "lock", "studyElements"]);
            return __assign(__assign({}, state), { current: __assign(__assign({}, state.current), { hardData: hardData, studyElements: studyElements, data: rest, actions: actions, contracts: contracts, documents: documents, applicants: applicants, lock: lock, soa3UploadPath: soa3UploadModulePath }) });
        }
        case E_CASES_ACTION_TYPES.UPDATE_DOC_STATUS_LOADING: {
            var documents = action.documents;
            return __assign(__assign({}, state), { current: __assign(__assign({}, state.current), { documents: documents }) });
        }
        case E_CASES_ACTION_TYPES.SAVE_ALL_QUERIES: {
            var allQueries = action.allQueries;
            return __assign(__assign({}, state), { allQueries: allQueries });
        }
        case E_CASES_ACTION_TYPES.SET_DEFAULT_FILTER: {
            var filters = action.filters;
            return __assign(__assign({}, state), { collection: __assign(__assign({}, state.collection), { defaultFilters: filters }) });
        }
        case E_CASES_ACTION_TYPES.RESET_FILTERS: {
            return __assign(__assign({}, state), { collection: __assign(__assign({}, state.collection), { filters: state.collection.defaultFilters }) });
        }
        case E_CASES_ACTION_TYPES.UPDATE_SEARCH_FILTERS_SUCCEEDED: {
            var filters = action.filters;
            return __assign(__assign({}, state), { collection: __assign(__assign({}, state.collection), { filters: __assign(__assign({}, state.collection.filters), filters) }) });
        }
        case E_CASES_ACTION_TYPES.SAVE_ALL_COLUMNS: {
            var allColumns = action.allColumns;
            return __assign(__assign({}, state), { allColumns: allColumns });
        }
        case E_CASES_ACTION_TYPES.UPDATE_COLUMN_SUCCEEDED: {
            var columns = action.columns;
            return __assign(__assign({}, state), { collection: __assign(__assign({}, state.collection), { columns: columns }) });
        }
        case E_CASES_ACTION_TYPES.UPDATE_DEFAULT_COLUMN_SUCCEEDED: {
            var columns = action.columns;
            return __assign(__assign({}, state), { collection: __assign(__assign({}, state.collection), { defaultColumns: columns }) });
        }
        case E_CASES_ACTION_TYPES.UPDATE_CURRENT_CASE_HISTORY_SUCCEEDED: {
            var history_1 = action.history;
            return __assign(__assign({}, state), { current: __assign(__assign({}, state.current), { history: __assign(__assign({}, state.current.history), { events: history_1 }) }) });
        }
        case E_CASES_ACTION_TYPES.UPDATE_CURRENT_CASE_COMMENT_SUCCEEDED: {
            var comments = action.comments;
            return __assign(__assign({}, state), { current: __assign(__assign({}, state.current), { comments: comments }) });
        }
        case E_CASES_ACTION_TYPES.UPDATE_TEMPLATE_SUCCEEDED: {
            var template = action.template;
            return __assign(__assign({}, state), { currentTemplate: template });
        }
        case E_CASES_ACTION_TYPES.UPDATE_HISTORY_FILTERS: {
            var historyFilters = action.historyFilters;
            return __assign(__assign({}, state), { current: __assign(__assign({}, state.current), { history: __assign(__assign({}, state.current.history), { filters: __assign(__assign({}, state.current.history.filters), { current: historyFilters }) }) }) });
        }
        case E_CASES_ACTION_TYPES.UPDATE_CURRENT_APPLICANT: {
            var currentApplicantId = action.currentApplicantId;
            return __assign(__assign({}, state), { currentApplicantId: currentApplicantId });
        }
        case E_CASES_ACTION_TYPES.CLEAR_CURRENT_CASE: {
            return __assign(__assign({}, state), { current: initialState.current, currentTemplate: initialState.currentTemplate, currentApplicantId: initialState.currentApplicantId });
        }
        case E_CASES_ACTION_TYPES.RESET_HISTORY_FILTERS: {
            return __assign(__assign({}, state), { current: __assign(__assign({}, state.current), { history: __assign(__assign({}, state.current.history), { filters: __assign(__assign({}, state.current.history.filters), { current: initialState.current.history.filters.current }) }) }) });
        }
        case E_CASES_ACTION_TYPES.UPDATE_ACTION_MODAL: {
            var actionModal = action.actionModal;
            return __assign(__assign({}, state), { current: __assign(__assign({}, state.current), { actionModal: __assign(__assign({}, state.current.actionModal), { content: actionModal }) }) });
        }
        case E_CASES_ACTION_TYPES.UPDATE_ACTION_MODAL_LOADING: {
            var isLoading = action.isLoading;
            return __assign(__assign({}, state), { current: __assign(__assign({}, state.current), { actionModal: __assign(__assign({}, state.current.actionModal), { isLoading: isLoading }) }) });
        }
        case E_CASES_ACTION_TYPES.UPDATE_MODAL_CACHE: {
            var params = action.params;
            return __assign(__assign({}, state), { current: __assign(__assign({}, state.current), { modal: __assign(__assign({}, state.current.modal), { cache: params }) }) });
        }
        case E_CASES_ACTION_TYPES.RESET_MODAL_CACHE: {
            return __assign(__assign({}, state), { current: __assign(__assign({}, state.current), { modal: initialState.current.modal }) });
        }
        case E_CASES_ACTION_TYPES.FETCH_CONTRACTS_SUCCEEDED: {
            var contracts = action.contracts;
            return __assign(__assign({}, state), { current: __assign(__assign({}, state.current), { contracts: contracts }) });
        }
        case E_CASES_ACTION_TYPES.UPDATE_CURRENT_CASE_LOADING: {
            var isLoading = action.isLoading;
            return __assign(__assign({}, state), { current: __assign(__assign({}, state.current), { isLoading: isLoading }) });
        }
        case E_CASES_ACTION_TYPES.UPDATE_NOTIFICATION: {
            var isNotificationsActivated = action.isNotificationsActivated;
            return __assign(__assign({}, state), { isNotificationsActivated: isNotificationsActivated });
        }
        case E_CASES_ACTION_TYPES.UPDATE_CASES_EXPORT_LOADING: {
            var isLoading = action.isLoading;
            return __assign(__assign({}, state), { exportIsLoading: isLoading });
        }
        case E_CASES_ACTION_TYPES.UPDATE_MRZ_LINES_SUCCEEDED: {
            var applicants = action.applicants;
            return __assign(__assign({}, state), { current: __assign(__assign({}, state.current), { applicants: applicants }) });
        }
        case E_CASES_ACTION_TYPES.UPDATE_AUTO_PLAY: {
            var autoPlay = action.autoPlay;
            return __assign(__assign({}, state), { autoPlay: autoPlay });
        }
        default:
            return state;
    }
};
